import type {DomainsBaseStyles} from '../../types'
import {defaultStyles} from '../default-styles'

export const wiseCompareStylesUK: DomainsBaseStyles = {
  ...defaultStyles,
  COMMONS_APPBAR_BG: 'bg-[#c54c4c]',
  COMMONS_FOOTER_BG: 'bg-[#c54c4c]',
  HOMEPAGE_TOPRATED_BUTTON: 'border-[#c54c4c] hover:border-[#c54c4c] hover:bg-[#c54c4c] text-white',
  HOMEPAGE_CONTENT_DIVIDER: 'bg-[#c54c4c]',
  LISTPAGE_BADGE_WINNER_DIVIDER: '!divide-[#c54c4c]',
  LISTPAGE_BADGE_BEST_VALUE_DIVIDER: '!divide-[#c54c4c]',
  LISTPAGE_BUTTON_NEW_LAYOUT_SECONDARY:
    'border-[#c54c4c] text-[#c54c4c] [&>svg>path]:stroke-[#c54c4c] [&>svg>g>path]:stroke-[#c54c4c] [&>svg>path]:fill-[#c54c4c] [&>svg>g>path]:fill-[#c54c4c]',
  LISTPAGE_BUTTON_SECONDARY:
    'border-[#c54c4c] text-[#c54c4c] [&>svg>path]:stroke-[#d32b2b] [&>svg>g>path]:stroke-[#d32b2b] [&>svg>path]:fill-[#d32b2b] [&>svg>g>path]:fill-[#d32b2b]',
  LISTPAGE_BADGE_PLACEMENT_TEXT: 'text-[#c54c4c]',
  LISTPAGE_BADGE_WINNER_TEXT: 'text-[#c54c4c]',
  LISTPAGE_BADGE_SCORE_TEXT: 'text-[#c54c4c]',
  LISTPAGE_BADGE_EDITORS_CHOICE_TEXT: 'text-[#c54c4c]',
  LISTPAGE_BADGE_EDITORS_CHOICE_ICON_STROKE: 'stroke-[#c54c4c]',
  LISTPAGE_WIDGETS_RECOMMENDED_PRODUCTS:
    'bg-[#30040476] [&>.vector-top>path]:fill-[#c54c4c] [&>.vector-bottom>path]:fill-[#c54c4c]',
  LISTPAGE_WIDGETS_SPECS_CHECKED_ICON: '[&>circle]:fill-[#300404] [&>circle]:stroke-[#300404] [&>path]:fill-[#c54c4c]',
  LISTPAGE_BUTTON_PRIMARY:
    'bg-[#d32b2b] text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_NEW_LAYOUT_PRIMARY:
    'bg-[#d32b2b] text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_LINK: 'text-[#d32b2b]',
  LISTPAGE_BUTTON_NEW_LAYOUT_LINK: 'text-[#d32b2b] [&_path]:fill-[#d32b2b] [&_path]:stroke-[#d32b2b]',
  LISTPAGE_WIDGETS_SPECS_ACCORDION_BUTTON_BG: 'bg-[#d32b2b]',
  LISTPAGE_BUTTON_ICON_FILL: 'fill-[#d32b2b]',
  LISTPAGE_BUTTON_NEW_LAYOUT_ICON_FILL: 'fill-[#d32b2b]',
  LISTPAGE_BUTTON_ICON_STROKE: 'stroke-[#d32b2b]',
  LISTPAGE_BUTTON_NEW_LAYOUT_ICON_STROKE: 'stroke-[#d32b2b]',
  LISTPAGE_USER_VALUE_BADGE: 'text-gray-900 [&>div>svg>path]:fill-[#030303] bg-[#300404]',
  LISTPAGE_BADGE_PLACEMENT_BG: 'bg-[#300404]',
  LISTPAGE_BADGE_BEST_VALUE_BG: 'bg-[#300404]',
  LISTPAGE_BADGE_WINNER_BG: 'bg-[#300404]',
  LISTPAGE_BADGE_CTA_DISCOUNT_BG: 'bg-[#300404]',
  LISTPAGE_BADGE_CTA_MARKETPLACE_LOGO_BG: 'bg-[#300404]',
  LISTPAGE_BADGE_CTA_MARKETPLACE_LOGO_TEXT: 'text-white',
  LISTPAGE_BADGE_CTA_MARKETPLACE_LOGO_ICON: '[&>svg>g>g>g>.fill-current]:fill-white',
  LISTPAGE_BADGE_SPONSORED_BG: 'bg-[#e56262]',
  LISTPAGE_BADGE_CARD_DISCOUNT_BG: 'bg-[#e56262] text-white',
  LISTPAGE_BADGE_CARD_DISCOUNT_OLD_BG: 'bg-[#e56262]',
  LISTPAGE_BUTTON_ARROW_BG: 'bg-[#e56262]',
  LISTPAGE_BUTTON_NEW_LAYOUT_ARROW_BG: 'bg-[#e56262]',

  LISTPAGE_BADGE_CARD_DISCOUNT_OLD_TEXT: 'text-white',

  UTILS_MAIN_CONTAINER: 'content-container',
}
